import { render } from "./EventCreate.vue?vue&type=template&id=26bc706d"
import script from "./EventCreate.vue?vue&type=script&lang=ts"
export * from "./EventCreate.vue?vue&type=script&lang=ts"

import "./EventCreate.vue?vue&type=style&index=0&id=26bc706d&lang=css"
script.render = render

export default script